/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import VeeValidate from 'vee-validate';
import vueHeadful from 'vue-headful';
import VueCarousel from 'vue-carousel';


Vue.use(VeeValidate);
Vue.use(VueCarousel);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */


//
// Vue.component('vue-headful', vueHeadful);
Vue.component('banner', require('./' + process.env.MIX_THEME + '/components/Banner.vue').default);
// Vue.component('clients-details', require('./' + process.env.MIX_THEME + '/components/Clients.vue').default);
// Vue.component('news', require('./' + process.env.MIX_THEME + '/components/NewsList.vue').default);
// Vue.component('news-detail', require('./' + process.env.MIX_THEME + '/components/NewsDetail.vue').default);
// Vue.component('services', require('./' + process.env.MIX_THEME + '/components/ServiceList.vue').default);
// Vue.component('service-detail', require('./' + process.env.MIX_THEME + '/components/ServiceDetail.vue').default);
// Vue.component('testimonials', require('./' + process.env.MIX_THEME + '/components/TestimonialList.vue').default);

Vue.component('user', require('./' + process.env.MIX_THEME + '/components/User.vue').default);
// Vue.component('about', require('./' + process.env.MIX_THEME + '/components/About.vue').default);
// Vue.component('sidebar-nav', require('./' + process.env.MIX_THEME + '/components/sidebarNav.vue').default);
// Vue.component('thankyou', require('./' + process.env.MIX_THEME + '/components/Thankyou.vue').default);
// Vue.component('services-links', require('./' + process.env.MIX_THEME + '/components/ServiceLinks.vue').default);
// Vue.component('home-description', require('./' + process.env.MIX_THEME + '/components/homeDesc.vue').default);
// Vue.component('inner-header-bg', require('./' + process.env.MIX_THEME + '/components/innerHeaderBg.vue').default);
// Vue.component('categories-links', require('./' + process.env.MIX_THEME + '/components/CategoriesLinks.vue').default);
// Vue.component('categories-nodes', require('./' + process.env.MIX_THEME + '/components/CategoriesNodes.vue').default);
// Vue.component('our-portfolio', require('./' + process.env.MIX_THEME + '/components/ourPortfolio.vue').default);
// Vue.component('portfolio-detail', require('./' + process.env.MIX_THEME + '/components/ourPortfolioDetail.vue').default);
// Vue.component('our-products', require('./' + process.env.MIX_THEME + '/components/productList.vue').default);
// Vue.component('product-detail', require('./' + process.env.MIX_THEME + '/components/ourProductDetail.vue').default);
// Vue.component('technical-resource', require('./' + process.env.MIX_THEME + '/components/technicalResource.vue').default);
// Vue.component('category-products', require('./' + process.env.MIX_THEME + '/components/categoryProducts.vue').default);
// Vue.component('products-links', require('./' + process.env.MIX_THEME + '/components/ProductLinks.vue').default);
// Vue.component('order', require('./' + process.env.MIX_THEME + '/components/Order.vue').default);
// Vue.component('portfolio-listing', require('./' + process.env.MIX_THEME + '/components/PortfolioListing.vue').default);
// Vue.component('services-listing', require('./' + process.env.MIX_THEME + '/components/ServicesListing.vue').default);


Vue.component('attribute', require('./' + process.env.MIX_THEME + '/components/Attribute.vue').default);
Vue.component('product-attribute', require('./' + process.env.MIX_THEME + '/components/ProductAttribute.vue').default);
Vue.component('request-quote', require('./' + process.env.MIX_THEME + '/components/requestQuote.vue').default);
Vue.component('request-header', require('./' + process.env.MIX_THEME + '/components/requestQuoteHeader.vue').default);

Vue.component('product-table', require('./' + process.env.MIX_THEME + '/components/productTable.vue').default);

// Vue.component('cad', require('./' + process.env.MIX_THEME + '/components/cad.vue').default);


// admin
Vue.component('category', require('./customadmin/category.vue').default);
Vue.component('category-admin', require('./customadmin/categoryAdmin.vue').default);

Vue.component('product-filter', require('./customadmin/productFilter.vue').default);
Vue.component('product-admin', require('./customadmin/productAdmin.vue').default);
// custom admin panel components

Vue.component('upload-product-csv', require('./customadmin/ProductCsvUpload.vue').default);



// Vue.component('resource', require('./' + process.env.MIX_THEME + '/components/resource.vue').default);

// Vue.component('page-action', require('./' + process.env.MIX_THEME + '/components/pageAction.vue').default);
Vue.component('share', require('./' + process.env.MIX_THEME + '/components/Share.vue').default);

// Vue.component('gallery', require('./' + process.env.MIX_THEME + '/components/gallery.vue').default);
//
// Vue.component('career', require('./' + process.env.MIX_THEME + '/components/career.vue').default);
//
// Vue.component('career-form', require('./' + process.env.MIX_THEME + '/components/careerForm.vue').default);

Vue.component('upload-category-csv', require('./customadmin/CategoryCsvUpload.vue').default);
Vue.component('add-new-category', require('./customadmin/addNewCategory.vue').default);


// Vue.component('sync-category-tree', require('./customadmin/synCategoryTree.vue').default);

// Home page components


Vue.component('newsletter',require('./'+ process.env.MIX_THEME + '/components/Newsletter.vue').default);
Vue.component('product-admin', require('./customadmin/productAdmin.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data: {
        websitename: process.env.MIX_THEME,
        ga4_session_id: window.ga4_session_id,
    },
});
